import React, {useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import FInfoCard from "../../components/FInfoCard/FInfoCard";
import { useContactInfo } from "../../hooks/useContactInfo";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import FContainer from "../../components/FContainer/FContainer";
import { AuthContext } from "../../context/AuthContext";
import jwt_decode from "jwt-decode";

const PhoneScreen = ({ param }) => {
  const token = localStorage.getItem("token");
  const tokenDecode = jwt_decode(token);
  const route = useNavigate();
  const { getPhones, phones, deleteContactInfo, loadPhones, isRefreshing } =
    useContactInfo();
  useEffect(() => {
    getPhones();
  }, []);

  return (
    <>
      <FBannerTitleButton
        title="Asocia un teléfono celular a tu cuenta"
        imageUrl={require("../../components/assets/images/telephone.png")}
        titleButton={
          <Fbutton
            value="Agregar Celular"
            onClick={() => {
              route("/CreatePhoneScreen");
            }}
          />
        }
      />
      <FContainer>
      <FInfoCard
          title="Teléfono de la cuenta"
          contact={tokenDecode.phoneNumber}
          typeOfContactId="PHONE"
          trash={false}
          disable={true}
          star={true}
      />

        {!phones ? (
          <div>
          </div>
        ) : (
          phones.map((item) => (
            <>
              <FInfoCard
                title="Teléfono"
                typeOfContactId={item.typeOfContactId}
                contact={item.contact}
                item={item}
                onDeleteClick={(value) =>
                  deleteContactInfo(value.typeOfContactId, value.id)
                }
              />
            </>
          ))
        )}
      </FContainer>
    </>
  );
};

export default PhoneScreen;